export enum KeyCodes {
  Backspace = 8,
  Tab = 9,
  Enter = 13,
  Shift = 16,
  Esc = 27,
  Space = 32,
  Left = 37,
  Up = 38,
  Right = 39,
  Down = 40,
  Zero = 48,
  C = 67,
  S = 83,
  V = 86,
  Z = 90,
  EqualSign = 187,
  Dash = 189,
}
